import { useEffect } from 'react';
import { AddonBlueprint } from '@backstage/plugin-techdocs-react/alpha';
import { useShadowRoot, TechDocsAddonLocations } from '@backstage/plugin-techdocs-react';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { renderMermaidCandidates } from './mermaid/mermaidRenderer';

const MermaidAddonComponent = () => {
  const shadowRoot = useShadowRoot();

  useEffect(() => {
    if (!shadowRoot) return;

    const scan = () => {
      // Query all possible containers: explicit .mermaid divs AND any pre>code blocks
      // (techdocs-core/pygments may not add language classes to <code>)
      const candidates: Element[] = [
        ...Array.from(shadowRoot.querySelectorAll('.mermaid')),
        ...Array.from(shadowRoot.querySelectorAll('pre code')),
      ];
      renderMermaidCandidates(candidates);
    };

    scan();

    const observer = new MutationObserver(scan);
    observer.observe(shadowRoot, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, [shadowRoot]);

  return null;
};

const mermaidAddon = AddonBlueprint.make({
  name: 'mermaid',
  params: {
    name: 'Mermaid',
    location: TechDocsAddonLocations.Content,
    component: MermaidAddonComponent,
  },
});

export const mermaidAddonModule = createFrontendModule({
  pluginId: 'techdocs',
  extensions: [mermaidAddon],
});
